module.exports = __webpack_public_path__ + "img/status_success.fe4f31c3.png";